import { render, staticRenderFns } from "./OperationsResourceList.vue?vue&type=template&id=5a918f2e&scoped=true"
import script from "./OperationsResourceList.vue?vue&type=script&lang=js"
export * from "./OperationsResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a918f2e",
  null
  
)

export default component.exports